import { getLoginUser, logout, getMainBranchLogo, getTenantSummary } from '../../api/user'
import { Storage } from '@yld/yun-utils-common'

const state = {
  userInfo: {},
  name: '',
  avatar: '',
  logoUrl: '', // logo地址
  id: null,
  tenantId: null, // 租户Id
  // 租户信息
  tenantSummaryInfo: {}
}

const mutations = {
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_TENANTID: (state, tenantId) => {
    state.tenantId = tenantId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_LOGOURL: (state, logoUrl) => {
    state.logoUrl = logoUrl
  },
  // 租户信息
  SET_TENANTSUMMARYINFO: (state, tenantSummaryInfo) => {
    state.tenantSummaryInfo = tenantSummaryInfo
  }
}

const actions = {
  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getLoginUser().then(response => {
        const { data } = response
        if (data) {
          commit('SET_ID', data.id)
          commit('SET_TENANTID', data.tenantId)
          commit('SET_NAME', data.realName)
          commit('SET_AVATAR', data.thumbAvatar)
          commit('SET_USERINFO', data)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取分公司logo
  getLogoUrl({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      getMainBranchLogo().then((response) => {
        const { data } = response
        if (data) {
          commit('SET_LOGOURL', data)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        Storage.clearStorage()
        // 本地环境 和 测试环境
        // window && window.location.replace('http://test-iam.sdlandsea.net/#/passport/logout?client_id=1180946496460161024&response_type=code&redirect_uri=')
        // 生产环境
        window && window.location.replace('https://iam.sdland-sea.com/#/passport/logout?client_id=1180946496460161024&response_type=code&redirect_uri=https://fare.i-ebs.com')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 租户
  getTenantSummaryInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getTenantSummary().then(response => {
        const { data } = response
        if (data) {
          commit('SET_TENANTSUMMARYINFO', data)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
